module.exports = __webpack_public_path__ + "img/nobilabo.05f13687.png";